import { action, fsa } from "ts-action";
import { DataSourceId, SystemNotification } from "../../../globalTypes";

export const receiveSystemNotification = action(
  "NOTIFICATIONS : SYSTEM > GET MESSAGES > RECEIVE (signalR)",
  fsa<{ notification: SystemNotification }>()
);

export const requestSystemNotifications = action(
  "NOTIFICATIONS : SYSTEM > GET MESSAGES > REQUEST"
);

export const receiveSystemNotifications = action(
  "NOTIFICATIONS : SYSTEM > GET MESSAGES > RECEIVE (signalR)", // aby bylo v devtools jasnější, že se to může dispatchnout i bez requestu
  fsa<{ notifications: SystemNotification[] }>()
);

export const errorRequestSystemNotifications = action(
  "NOTIFICATIONS : SYSTEM > GET MESSAGES > ERROR"
);

export const dismissMappingNotificationForDatasource = action(
  "NOTIFICATIONS : SYSTEM > MAPPING > DISMISS",
  fsa<{ datasourceId: DataSourceId }>()
);
